import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import { mockTransactionGroups } from 'src/app/core/mock/mockTransactionGroups'
import { representativesSpecialAttributes } from '../mock/representativesSpecialAttributes'
import LegalRepresentative from '../models/LegalRepresentative'
import LegalRepresentativeExtended from '../models/LegalRepresentativeExtended'
import LookUp from '../models/LookUp'

@Injectable({
  providedIn: 'root',
})
export class TransactionGroupsService {
  public hasSAU = new BehaviorSubject<boolean>(false) 
  constructor() {}

  getTransactionGroupTabs() {
    const res = []
    mockTransactionGroups.forEach((x) => {
      const item = {
        tab: 'transactionGroup_' + x.id,
        icon: 'briefcase',
        text: x.sidebarText,
        longText: x.sidebarLongText,
      }
      res.push(item)
    })
    return res
  }

  getTransactionGroupById(groupId: number) {
    return mockTransactionGroups.find((x) => x.id === groupId)
  }

  getAllTransactionGroupLookup() {
    const res: Array<LookUp> = []
    mockTransactionGroups.forEach((x) => {
      const item: LookUp = {
        id: x.id,
        value: x.name,
      }
      res.push(item)
    })
    return res
  }

  mapLegalRepresentativesToLegalRepresentativesExtented(
    legalrepresentatives: Array<LegalRepresentative>,
    groupId: number
  ): Array<LegalRepresentativeExtended> {
    let output = legalrepresentatives.map((r) => {
      const result = new LegalRepresentativeExtended()
      result.relType = r.relType
      result.relSequence = r.relSequence
      result.firstName = r.firstName
      result.lastName = r.lastName
      result.fatherName = r.fatherName
      result.afm = r.afm
      result.fullName = r.fullName
      result.isFromAltamira = r.isFromAltamira
      result.specialAttributeIds = r.specialAttributeIds
      result.disabled = this.getDisabled(groupId, r.specialAttributeIds)

      return result
    })

    return output
  }

  private getDisabled(groupId: number, specialAttributeIds: Array<number>) {
    let groupIdsToCheck = [8, 9, 10]
    if (groupIdsToCheck.includes(groupId)) {
      if (specialAttributeIds == null) {
        return true
      }
      let disabled = true
      const attributesWithgivenGroupId = representativesSpecialAttributes
        .filter((r) => r.previewInGroupIds.includes(groupId))
        .map((t) => t.id)
      disabled = !specialAttributeIds.some((x) => attributesWithgivenGroupId.includes(x))
      return disabled
    } else {
      return false
    }
  }
}
